import PoolDetails from './pool-details';

export default PoolDetails;
